import { FormView, Layout, RegisterForm, SEO } from '@components';
import { getGlobalProps } from '@utils/get-global-props';
import { useTranslation } from '@utils/index';

const getTranslatedTexts = translator => {
	return {
		createAnAccountTitle: translator('create-an-account-page-title'),
	};
};

const Register = () => {
	const { translator } = useTranslation();
	const translations = getTranslatedTexts(translator);

	return (
		<>
			<SEO title={translations.createAnAccountTitle} />
			<FormView Form={RegisterForm} />
		</>
	);
};

export async function getStaticProps({ locale }) {
	const globalProps = await getGlobalProps({ locale });
	return {
		props: {
			...globalProps,
		},
	};
}

Register.getLayout = function getLayout(page, pageProps) {
	return <Layout pageProps={pageProps}>{page}</Layout>;
};

export default Register;
